import PropTypes from 'prop-types';
import React from 'react';

import { Box, Card, CardContent, Paper, Skeleton, Typography, ViewContainer } from 'components/AORedesign';

const BillingDetailsSkeleton = ({ items = 1 }) => {
  return (
    <ViewContainer>
      <Card>
        <Box pl={2}>
          <Typography variant="h4">
            <Skeleton width={200} />
          </Typography>
        </Box>
        <CardContent>
          {Array.from(Array(items).keys()).map((index) => (
            <React.Fragment key={index}>
              <Paper>
                <Skeleton width={100} style={{ marginRight: `24px`, padding: `6px 8px` }} animation="wave" />
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={200} />
              </Paper>
              <Box mb={3} />
            </React.Fragment>
          ))}
        </CardContent>
      </Card>
    </ViewContainer>
  );
};

BillingDetailsSkeleton.propTypes = {
  items: PropTypes.number,
};

export default BillingDetailsSkeleton;
